const between = (a, b, x) => a < x && x <= b

export const vfnColor = (colA, vfn, colB, val) =>
    between(0, parseFloat(colA), parseFloat(val))
        ? 10
        : between(parseFloat(colA), parseFloat(vfn), parseFloat(val))
            ? 11
            : between(parseFloat(vfn), parseFloat(colB), parseFloat(val))
                ? 12
                : 13

export const vfnShape = (colA, vfn, val) =>
    between(parseFloat(colA), parseFloat(vfn), parseFloat(val))
        ? "square"
        : "circle"